import { Usuario } from './usuario.model';

export class Comentario {
    id: number;
    estimativaId: number;
    usuarioId: number;
    mensagem: string;
    dtInclusao: Date;
    dtAlteracao?: Date;
    ativo: boolean;
    usuario: Usuario;
}
